module.exports = __webpack_public_path__ + "img/insider-logo.6b576424.svg";